/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Heading, Theme, useTheme, VFlow } from 'bold-ui'
import { useMemo } from 'react'

interface HistoricoVacinacaoBoxTableProps<T> {
  registroAnterior?: boolean
  items: T[]
  renderItem(item: T): React.ReactNode
}

export default function HistoricoVacinacaoBoxTable<T extends { id: ID }>(props: HistoricoVacinacaoBoxTableProps<T>) {
  const { registroAnterior, items, renderItem } = props
  const theme = useTheme()
  const classes = styles(theme)

  const renderItems = useMemo(() => items.map((item) => renderItem(item)), [items, renderItem])

  return (
    <VFlow vSpacing={0} style={classes.wrapper}>
      <Heading level={5}>{registroAnterior ? `Registro anterior` : `Registro de aplicação`}</Heading>
      {renderItems}
    </VFlow>
  )
}

const styles = (theme: Theme) => ({
  wrapper: css`
    border: 1px solid ${theme.pallete.divider};
    & > * {
      padding: 0.5rem 1rem;
    }
    & > :not(:last-child) {
      border-bottom: 1px solid ${theme.pallete.divider};
    }
  `,
})
